import { appConfig } from "src/config";
import { send } from "src/utils/fetch";
import { getAnonymousClientAuthorizationHeader } from "src/api/utils";
import {
  ComputePurchaseIntentEltvRequestProto_Body,
  ComputePurchaseIntentEltvResponseProto,
} from "@noom/noom-contracts/noom_contracts/backend/marketing/eltv_service";

export type ComputeEltvRequest = ComputePurchaseIntentEltvRequestProto_Body;
export type ComputeEltvResponse = ComputePurchaseIntentEltvResponseProto;

export async function fetchEltv(
  requestBody: ComputeEltvRequest
): Promise<ComputeEltvResponse> {
  return send<ComputeEltvResponse>(
    "POST",
    `${appConfig.MARKETING_API_URL}/v1/eltv/computePurchaseIntentEltv`,
    requestBody,
    { headers: getAnonymousClientAuthorizationHeader() }
  );
}
